import { evalExpression } from 'ng-formly/src/core/utils';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { FieldType } from 'ng-formly';
import { PicklistApi } from '../../sdk/services/custom';
import * as _ from "lodash";
import { PlatformApp } from '../../services/app.service';

/*
This custom field is used to select options for an app.
*/

@Component({
    selector: 'formly-picklist-lookup',
    template: `
   <ng-select *ngIf='items.length > 0'   
             [active]='selectedvalues'
              (data)='refreshValue($event)'
              (selected)='selected($event)'
              (removed)='removed($event)'
              [items]='items'
              [multiple] = 'false'
              [disabled]='to.disabled'
              placeholder='',
              [allowClear]='!to.required' >
  </ng-select>
  `, styleUrls: ['./ng2select.scss']
})
export class PicklistLookup extends FieldType implements OnInit, OnDestroy {

    items: any = [];
    selectedvalues: any = [];
    value: any = {};

    constructor(private _PicklistApi: PicklistApi) {
        super();
    }

    formulae = [];
    modelValues = [];

    ngOnInit() {
        if (!this.form['subscriptions'])
            this.form['subscriptions'] = [];

        // Adding new Controls to hold formControls for hidden fields
        if (!this.form['newcontrols'])
            this.form['newcontrols'] = {};

        for (var key in this.form.controls)
            this.form['newcontrols'][key] = this.form.controls[key];

        if (this.field['formulae']) {
            this.formulae = this.field['formulae'];
            if (this.field.formControl)
                this.addWatcher(this.field.formControl);
        }

        if (this.field.defaultValue && !this.model[this.key])
            this.formControl.setValue(this.field.defaultValue);

        if (this.field['lookupfield']) {
            let expProp = this.field['expressionProperties'];
            if (expProp && expProp.hasOwnProperty('lookupfield'))
                this.field['lookupfield'] = evalExpression(expProp['lookupfield'].expression, this, [this.model, this.options.fromState]);

            this.form['subscriptions'].push(this._PicklistApi.findById(this.field['lookupfield']).subscribe((picklist) => {
                if (picklist && picklist['options']) {
                    this.populateValues(picklist['options']);
                }
            }));
        } else
            this.populateValues(this.field.templateOptions['options']);
    }

    private populateValues(options) {
        this.items = [];
        this.selectedvalues = [];

        if (options && options.length && options.length > 0) {
            for (var i = 0; i < options.length; i++) {
                this.items.push({ id: options[i]['value'], text: options[i]['label'] })

                if (this.model[this.key] && this.model[this.key].indexOf(options[i]['value']) > -1)
                    this.selectedvalues = [{ id: options[i]['value'], text: options[i]['label'] }];
            }
            this.items = _.sortBy(this.items, 'text');
            if (this.items.length == 1) {
                this.selectedvalues = _.cloneDeep(this.items);
                this.field.formControl.setValue(this.items[0].id);
                this.field.templateOptions.disabled = true;
            } else {
                this.field.templateOptions.disabled = false;
            }
        } else
            this.field.templateOptions.disabled = true;
    }

    private addWatcher(formControl) {
        this.form['subscriptions'].push(formControl.valueChanges.subscribe((updatedValue: any) => {
            for (var i = 0; i < this.formulae.length; i++) {
                var formula = this.formulae[i];
                if (this.setModelValues(formula['fields'], updatedValue))
                    this.setResults(formula['results'], PlatformApp.processData(formula['formula'], this.modelValues));
            }
        }));
    }

    private setModelValues(fieldArray, updatedValue) {
        var requiredFieldsExist = true;
        this.modelValues = [];
        for (var j = 0; j < fieldArray.length; j++) {
            if (!this.model[fieldArray[j]]) {
                requiredFieldsExist = false;
                break;
            } else {
                if (fieldArray[j] == this.field.key)
                    this.modelValues.push(updatedValue);
                else
                    this.modelValues.push(this.model[fieldArray[j]]);
            }
        }
        return requiredFieldsExist;
    }

    private setResults(resultArray, value): void {
        for (var i = 0; i < resultArray.length; i++) {
            var resultField = resultArray[i];
            if (this.form.controls[resultField]) {
                this.form.controls[resultField].setValue(value);

                if (this.form['newcontrols'][resultField] && !this.model[resultField]) {
                    this.form.setControl(resultField, this.form['newcontrols'][resultField]);
                    this.form.controls[resultField].setValue(value);
                }
            } else {
                if (this.form['newcontrols'][resultField]) {
                    this.form.addControl(resultField, this.form['newcontrols'][resultField]);
                    this.form.controls[resultField].setValue(value);
                } else {
                    this.model[resultField] = value;
                }
            }
        }
    }

    ngOnDestroy() {
        this.selectedvalues = [];
    }

    public selected(value: any): void {
        if (value && value.id)
            this.formControl.setValue(value.id);

        for (var key in this.form['newcontrols'])
            this.form.setControl(key, this.form['newcontrols'][key]);
    }

    public removed(value: any): void {
        if (value && value.id)
            if (this.model[this.key] && this.model[this.key].length)
                this.model[this.key].splice(this.model[this.key].indexOf(value.id), 1);
    }

    public typed(value: any): void {

    }

    public refreshValue(value: any): void {
        this.value = value;
    }

}





// WEBPACK FOOTER //
// ./src/app/shared/components/fields/lookuppicklist.ts